import React, { useEffect, useState } from "react";

export default function useDayPickerKeyboardNavigation({ days = [], isOpen }) {
  const [activeDay, setActiveDay] = useState(null);

  const handleDownArrow = () => {
    if (!activeDay) {
      setActiveDay(days[0]);
      return;
    }

    let next = activeDay + 7;
    if (next > days.length) {
      next = days.length;
    }
    setActiveDay(next);
  };

  const handleUpArrow = () => {
    if (!activeDay) {
      setActiveDay(days[0]);
      return;
    }

    let next = activeDay - 7;
    if (next <= 0) {
      next = 1;
    }
    setActiveDay(next);
  };

  const handleLeftArrow = () => {
    if (!activeDay) {
      setActiveDay(days[0]);
      return;
    }

    let next = activeDay - 1;
    if (next <= 0) return;

    setActiveDay(next);
  };

  const handleRightArrow = () => {
    if (!activeDay) {
      setActiveDay(days[0]);
      return;
    }

    let next = activeDay + 1;
    if (next > days.length) {
      next = days.length;
    }
    setActiveDay(next);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 40) {
      e.preventDefault();
      handleDownArrow();
    } else if (e.keyCode === 38) {
      e.preventDefault();
      handleUpArrow();
    } else if (e.keyCode === 37) {
      e.preventDefault();
      handleLeftArrow();
    } else if (e.keyCode === 39) {
      e.preventDefault();
      handleRightArrow();
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setActiveDay(undefined);
    }
  }, [isOpen]);

  return {
    activeDay,
    handleKeyDown,
  };
}
